// Court upgrades — per-court binary installs (unlike facility level tracks).
// Their effects are declared as engine `Modifier`s with court scope; the
// ModifierSystem collects them and Economy/Demand/UI resolve them.
//
// Fase 1 cleanup: seasonal events moved to seasonalConfig.ts; the legacy
// bronze/silver/gold league block (unused since the real league system in
// leagueConfig.ts) was deleted.

import type { Modifier } from '@/game/systems/ModifierSystem'

export interface CourtUpgrade {
  id: string
  name: string
  emoji: string
  description: string
  cost: number
  modifiers: Modifier[]
  applicableTo: ('outdoor' | 'indoor')[]
}

export const COURT_UPGRADES: CourtUpgrade[] = [
  {
    id: 'led_lighting',
    name: 'Iluminación LED',
    emoji: '💡',
    description: 'Permite jugar en horario nocturno',
    cost: 1500,
    modifiers: [
      { stat: 'income.court_rental', op: 'mult', value: 1.2, scope: 'court' },
      { stat: 'satisfaction', op: 'add', value: 5, scope: 'court' },
    ],
    applicableTo: ['outdoor', 'indoor'],
  },
  {
    id: 'premium_surface',
    name: 'Superficie Premium',
    emoji: '✨',
    description: 'Césped artificial de última generación',
    cost: 3000,
    modifiers: [
      { stat: 'court.condition_decay', op: 'mult', value: 0.5, scope: 'court' }, // 50% slower wear
      { stat: 'satisfaction', op: 'add', value: 10, scope: 'court' },
      { stat: 'court.premium_price', op: 'add', value: 10, scope: 'court' },
    ],
    applicableTo: ['outdoor', 'indoor'],
  },
  {
    id: 'climate_control',
    name: 'Climatización',
    emoji: '❄️',
    description: 'Sistema de aire acondicionado',
    cost: 5000,
    modifiers: [
      { stat: 'income.court_rental', op: 'mult', value: 1.3, scope: 'court' },
      { stat: 'satisfaction', op: 'add', value: 15, scope: 'court' },
    ],
    applicableTo: ['indoor'],
  },
  {
    id: 'sound_system',
    name: 'Sistema de Sonido',
    emoji: '🔊',
    description: 'Altavoces para música ambiente',
    cost: 800,
    modifiers: [
      { stat: 'satisfaction', op: 'add', value: 8, scope: 'court' },
    ],
    applicableTo: ['outdoor', 'indoor'],
  },
  {
    id: 'glass_walls',
    name: 'Paredes de Cristal',
    emoji: '🪟',
    description: 'Cristal de alta calidad para mejor visibilidad',
    cost: 4000,
    modifiers: [
      { stat: 'court.premium_price', op: 'add', value: 15, scope: 'court' },
      { stat: 'satisfaction', op: 'add', value: 12, scope: 'court' },
    ],
    applicableTo: ['outdoor', 'indoor'],
  },
  {
    id: 'retractable_roof',
    name: 'Techo Retráctil',
    emoji: '🏠',
    description: 'Protección del clima sin perder aire libre',
    cost: 8000,
    modifiers: [
      { stat: 'income.court_rental', op: 'mult', value: 1.4, scope: 'court' }, // weather immune
      { stat: 'court.premium_price', op: 'add', value: 20, scope: 'court' },
    ],
    applicableTo: ['outdoor'],
  },
]
